module.exports = __webpack_public_path__ + "app/assets/images/bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/bg.jpg
// module id = 1117
// module chunks = 7